import Data from './data'

export default {
    list: () => [200, Data.list],
    get: () => {
        const { data } = Data.list
        return [200, data[0]]
    },
    activities: () => [200, Data.activitiesList.activities],
}
